/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Mathematics19Inputs */

const en__field__enum_teachingsubjects_subject_mathematics19 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Mathematics19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematics`)
};

const de__field__enum_teachingsubjects_subject_mathematics19 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Mathematics19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematik`)
};

/**
* | output |
* | --- |
* | "Mathematics" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Mathematics19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_mathematics19 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Mathematics19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Mathematics19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_mathematics19(inputs)
	return de__field__enum_teachingsubjects_subject_mathematics19(inputs)
});
export { _field__enum_teachingsubjects_subject_mathematics19 as "_field__enum_teachingSubjects_SUBJECT_MATHEMATICS" }